import NavBar from "components/navBar";

function Header() {
  return (
    <header>
      <NavBar />
    </header>
  );
}
export default Header;
